<p-dialog
  data-testid="order-item-dialog"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="dialogStyle()"
  [draggable]="false"
  [resizable]="true"
  [closable]="false"
  [header]="config.title | translate: { id: orderNumber }"
>
  <div class="flex flex-col h-full">
    @if (orderItems().length > 0) {
      <div class="mb-3 ml-2 text-sm font-medium text-gray-700 gap-2">
        <div data-testid="order-item-dialog-total-products">
          {{ "order.internal.order_items.total_products" | translate }}:
          {{ totalProducts() }}
        </div>
        <div data-testid="order-item-dialog-total-payment">
          {{ "order.internal.order_items.total_payment" | translate }}:
          {{ formatCurrency(totalPayment()) }}
        </div>
      </div>
    }

    <!-- Order Items Table -->
    <app-data-table
      data-testid="order-item-dialog-table"
      [dataSource]="orderItems()"
      [columns]="tableColumns"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords()"
      [hasSerialColumn]="true"
      (pageChange)="onPageChange($event)"
      [scrollHeight]="'450px'"
      class="text-sm"
    >
      <ng-template #customTemplate let-rowData let-column="column">
        @if (column?.template === "currencyTemplate") {
          <span class="text-xs text-gray-600 flex items-center justify-end">
            {{ formatCurrency(rowData) }}
          </span>
        } @else if (column?.template === "quantityTemplate") {
          <span
            class="text-xs text-gray-600 flex items-center justify-end font-medium"
          >
            {{ rowData || 0 }}
          </span>
        }
      </ng-template>
    </app-data-table>

  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        data-testid="order-item-dialog-close-btn"
        [label]="'common.actions.close' | translate"
        severity="secondary"
        outlined="true"
        size="small"
        (onClick)="onClose()"
        [disabled]="loading()"
        styleClass="text-sm px-4 py-2"
      />
    </div>
  </ng-template>
</p-dialog>
